import React from "react";
import '../../css/sorting/sortable.less';
import Sorter from './Sorter';
import { direction } from '../constants';

/**
 * @param {String} direction One of contants/direction
 * @param {String} defaultDirection One of contants/direction - Which direction to sort on first click, usually DESC for numbers and dates and ASC for strings
 * @param {Function} onSort Passed one of contants/direction to indicate the newly selected direction
 * @description Creates a clickable element with a Sorter displayed inline to the right of any children
 */
class Sortable extends React.Component {
    
    constructor(props) {
        super();

        this.state = {
            direction: props.direction || direction.NONE
        };

        this.onSort = this.onSort.bind(this);
    }

    componentWillReceiveProps({ direction }) {
        if(direction !== this.state.direction) {
            this.setState({ direction });
        }
    }

    onSort() {
        const defaultDirection = this.props.defaultDirection || direction.ASC;
        const currentDirection = this.state.direction;

        const newDirection = 
            currentDirection === direction.NONE
            ? defaultDirection
                : currentDirection === direction.ASC
                ? direction.DESC
                    : direction.ASC;

        this.setState({
            direction: newDirection
        });

        this.props.onSort(newDirection);
    }
    
    render() {
        return (
            <span className="sortable" onClick={ this.onSort }>
                { this.props.children }
                <Sorter direction={this.state.direction} />
            </span>
        );
    }
};

export default Sortable;